// extracted by mini-css-extract-plugin
module.exports = {"DraftModeBanner":"DraftModeBanner_DraftModeBanner__S5ifs","DraftModeBanner__spinner":"DraftModeBanner_DraftModeBanner__spinner__ukvyv","rotate":"DraftModeBanner_rotate__oXTV_"};